import { createNetworkStatusNotifier } from 'react-apollo-network-status'

export const networkStatusNotifier = createNetworkStatusNotifier()
